import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateIvrProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  instantConnect: Types.Scalars['Boolean']['input'];
  timeout: Types.Scalars['Int']['input'];
  settings?: Types.InputMaybe<Types.IvrProfileSettings>;
  greetings?: Types.InputMaybe<Array<Types.UpdateIvrMenuMedia>>;
  menuMedia?: Types.InputMaybe<Array<Types.UpdateIvrMenuMedia>>;
  submenus?: Types.InputMaybe<Array<Types.SubmenuSettings>>;
  buttons?: Types.InputMaybe<Array<Types.InputMaybe<Types.UpdateIvrButton>>>;
}>;


export type UpdateIvrProfileMutation = { __typename?: 'Mutation', updateIvrProfile?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type ActivateIvrProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ActivateIvrProfileMutation = { __typename?: 'Mutation', activateIvrProfile: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string }> | null } };


export const UpdateIvrProfileDocument = gql`
    mutation UpdateIvrProfile($id: Int!, $name: String, $instantConnect: Boolean!, $timeout: Int!, $settings: IvrProfileSettings, $greetings: [UpdateIvrMenuMedia!], $menuMedia: [UpdateIvrMenuMedia!], $submenus: [SubmenuSettings!], $buttons: [UpdateIvrButton]) {
  updateIvrProfile(
    id: $id
    name: $name
    instantConnect: $instantConnect
    timeout: $timeout
    settings: $settings
    greetings: $greetings
    menuMedia: $menuMedia
    submenus: $submenus
    buttons: $buttons
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateIvrProfileMutationFn = Apollo.MutationFunction<UpdateIvrProfileMutation, UpdateIvrProfileMutationVariables>;

/**
 * __useUpdateIvrProfileMutation__
 *
 * To run a mutation, you first call `useUpdateIvrProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIvrProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIvrProfileMutation, { data, loading, error }] = useUpdateIvrProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      instantConnect: // value for 'instantConnect'
 *      timeout: // value for 'timeout'
 *      settings: // value for 'settings'
 *      greetings: // value for 'greetings'
 *      menuMedia: // value for 'menuMedia'
 *      submenus: // value for 'submenus'
 *      buttons: // value for 'buttons'
 *   },
 * });
 */
export function useUpdateIvrProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIvrProfileMutation, UpdateIvrProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIvrProfileMutation, UpdateIvrProfileMutationVariables>(UpdateIvrProfileDocument, options);
      }
export type UpdateIvrProfileMutationHookResult = ReturnType<typeof useUpdateIvrProfileMutation>;
export type UpdateIvrProfileMutationResult = Apollo.MutationResult<UpdateIvrProfileMutation>;
export type UpdateIvrProfileMutationOptions = Apollo.BaseMutationOptions<UpdateIvrProfileMutation, UpdateIvrProfileMutationVariables>;
export const ActivateIvrProfileDocument = gql`
    mutation ActivateIvrProfile($id: Int!) {
  activateIvrProfile(id: $id) {
    errors {
      type
    }
  }
}
    `;
export type ActivateIvrProfileMutationFn = Apollo.MutationFunction<ActivateIvrProfileMutation, ActivateIvrProfileMutationVariables>;

/**
 * __useActivateIvrProfileMutation__
 *
 * To run a mutation, you first call `useActivateIvrProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateIvrProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateIvrProfileMutation, { data, loading, error }] = useActivateIvrProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateIvrProfileMutation(baseOptions?: Apollo.MutationHookOptions<ActivateIvrProfileMutation, ActivateIvrProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateIvrProfileMutation, ActivateIvrProfileMutationVariables>(ActivateIvrProfileDocument, options);
      }
export type ActivateIvrProfileMutationHookResult = ReturnType<typeof useActivateIvrProfileMutation>;
export type ActivateIvrProfileMutationResult = Apollo.MutationResult<ActivateIvrProfileMutation>;
export type ActivateIvrProfileMutationOptions = Apollo.BaseMutationOptions<ActivateIvrProfileMutation, ActivateIvrProfileMutationVariables>;